import { useState } from 'react';
import { sendEvent, useEventNotification } from '../../features/visual-analytics/hooks/events';

import { ModalPortal } from '../modal-portal/ModalPortal';

import styles from './DataTableModal.module.scss';

const MSGDataTableModal = 'showDataTableModal';

interface TpDataTableModalData {
  headers: string[];
  rows: string[][];
  callBackOK: any;
  callBackCancel: any;
}

export function promptDataTableModal(tsvString: string, splitbyTab: boolean) {
  return new Promise((resolve, reject) => {
    function callBackOK() {
      resolve(true);
    }

    function callBackCancel() {
      reject();
    }

    const lines = tsvString.split('\n');
    const rows = [];
    for (const line of lines) {
      if (line.length > 0) {
        const cleanedLine = line.replace('\r', ''); // Some tables have \r\n line endings
        const cells = splitbyTab ? cleanedLine.split('\t') : cleanedLine.split(',');
        rows.push(cells);
      }
    }
    const headers: string[] = rows.shift() || [];

    const dataTableModalData: TpDataTableModalData = {
      headers,
      rows,
      callBackOK,
      callBackCancel,
    };
    sendEvent(MSGDataTableModal, dataTableModalData);
  });
}

export function DataTableModal() {
  const [dataTable, setDataTable] = useState<TpDataTableModalData | null>(null);

  useEventNotification(
    MSGDataTableModal,
    (tpe: string, contentInput: TpDataTableModalData) => {
      setDataTable(contentInput);
    },
    [],
  );

  if (!dataTable) return null;

  return (
    <ModalPortal
      keepBlur={true}
      close={() => {
        setDataTable(null);
      }}
    >
      <div style={{ height: '90vh', maxWidth: '1200px' }}>
        <div className={styles.tableWrapper}>
          {dataTable.headers.length > 0 && dataTable.rows.length > 0 && (
            <div className={styles.tableContainer}>
              <table>
                <thead>
                  <tr>
                    {dataTable.headers.map((element: any, index: number) => (
                      <th key={element.id} style={{ width: `${1200 / dataTable.headers.length}px`, textAlign: 'left' }}>
                        <i>{element}</i>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {dataTable.rows.map((element: any, index: number) => (
                    <tr key={element.id}>
                      {element.slice(0, dataTable.headers.length).map((cell: any, i: number) => (
                        <td style={{ width: `${1200 / dataTable.headers.length}px`, textAlign: 'left' }} key={i}>
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </ModalPortal>
  );
}
